export const REPORTS_BASIC = 'basic';
export const REPORTS_PLUS = 'plus';
export const REPORTS_PREMIUM = 'premium';
